export default "__VITE_ASSET__0fa3caa1__"